import { useEffect, useState } from "react";
import { formatDuration } from "./gameApi";

interface Props {
  /** Départ de la mission, ISO 8601 UTC. */
  startedAt: string;
}

/**
 * Chronomètre de mission.
 *
 * Il recalcule l'écoulé à partir de l'heure de DÉPART plutôt que d'incrémenter
 * un compteur : si le téléphone se met en veille ou si l'onglet passe en
 * arrière-plan, le navigateur suspend les minuteries et un compteur
 * dériverait. Ici l'affichage se recale tout seul au réveil.
 */
export default function MissionTimer({ startedAt }: Props) {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const start = Date.parse(startedAt);
    const tick = () => {
      setSeconds(Math.max(0, Math.round((Date.now() - start) / 1000)));
    };
    tick();
    const id = window.setInterval(tick, 1000);
    return () => {
      window.clearInterval(id);
    };
  }, [startedAt]);

  return (
    <span className="timer" role="timer" aria-live="off">
      {formatDuration(seconds)}
    </span>
  );
}
